var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 10,
    width: 25,
    height: 20,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20.755C30 22.3738 29.8 23.9925 29.8 23.9925C29.8 23.9925 29.605 25.37 29.005 25.9775C28.245 26.7738 27.3925 26.7775 27.0012 26.8237C24.2025 27.0263 20 27.0325 20 27.0325C20 27.0325 14.8 26.985 13.2 26.8325C12.755 26.7488 11.755 26.7738 10.995 25.9775C10.395 25.37 10.2 23.9925 10.2 23.9925C10.2 23.9925 10 22.3738 10 20.755V19.2375C10 17.6187 10.2 16.0013 10.2 16.0013C10.2 16.0013 10.395 14.6225 10.995 14.015C11.755 13.2188 12.6075 13.215 12.9987 13.1688C15.7975 12.9663 19.9963 12.9663 19.9963 12.9663H20.0037C20.0037 12.9663 24.2025 12.9663 27.0012 13.1688C27.3925 13.215 28.245 13.2188 29.005 14.015C29.605 14.6225 29.8 16.0013 29.8 16.0013C29.8 16.0013 30 17.6187 30 19.2375V20.755ZM20 0C8.95375 0 0 8.95375 0 20C0 31.045 8.95375 40 20 40C31.0462 40 40 31.045 40 20C40 8.95375 31.0462 0 20 0Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9352 22.5936L23.339 19.7936L17.934 16.9736L17.9352 22.5936Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.199147e970ea67bd8c4c6488f3c09152.svg";
export { ForwardRef as ReactComponent };